import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileHttp"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 8.25H18.75V15.75H20.25V13.5H22.5C23.3279 13.4988 23.9988 12.8279 24 12V9.75C23.9992 8.92192 23.3281 8.25083 22.5 8.25ZM20.25 12V9.75H22.5L22.5007 12H20.25ZM7.5 9.75H9V15.75H10.5V9.75H12V8.25H7.5V9.75ZM17.25 8.25H12.75V9.75H14.25V15.75H15.75V9.75H17.25V8.25ZM4.5 8.25V11.25H2.25V8.25H0.75V15.75H2.25V12.75H4.5V15.75H6V8.25H4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileHttp.vue"]]);
